import PropTypes from 'prop-types';

import RichText from '../../Core/RichText';
import Ctas from '../../Core/Ctas';

import {
  StyledContainer,
  Wrapper,
  TableTitle,
  TableRow,
  TableCell,
} from './styles';

const ContactTable = ({ data }) => {
  if (!data) return null;

  const { tableTitle, tableSections, tableFootnote } = data;

  return (
    <StyledContainer>
      <Wrapper>
        {tableTitle && (
          <TableTitle>
            <RichText document={tableTitle} />
          </TableTitle>
        )}
        {tableSections &&
          tableSections.map(({ id, row }) => {
            return (
              <TableRow key={`${id}-row`}>
                {row.map(({ id: cell_id, tableData, ctas }) => {
                  return (
                    <TableCell key={`${cell_id}-cell`}>
                      <RichText document={tableData} />
                      {ctas && <Ctas ctas={ctas} />}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        {tableFootnote && <RichText document={tableFootnote} />}
      </Wrapper>
    </StyledContainer>
  );
};

ContactTable.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ContactTable;
